import { Modal } from "antd";
import styled from "styled-components";

export const CommonModalStyle = styled(Modal)`
  .ant-modal-content {
    background-color: #fff;
  }

  .ant-modal-title {
    background-color: #fff;
    color: black;
  }
`;
